/**
 * Client-side marker for the chat connection lifecycle in the UI
 * and of the synthetic streaming-assistant message while a turn is in flight.
 * Not authoritative — the chat's server-side state lives in WireChat.status.
 */
export const CONNECTION_STATUS = {
  UNSET: 'unset',
  LOADING: 'loading',
  PROGRESS: 'progress',
  FINALIZED: 'finalized',
  ERRORED: 'errored',
  CANCELLED: 'cancelled',
  NETWORK_ERROR: 'network-error',
  /**
   * Recoverable interruption of an in-flight WS turn — a transparent socket
   * drop (network blip) that the client is auto-reconnecting + rejoining, or a
   * server shutdown (SIGTERM) whose turn will resume on the new pod. Surfaced
   * as a 'reconnecting' banner instead of a false CANCELLED / NETWORK_ERROR.
   * Only WebSocket connections enter this state.
   */
  RECONNECTING: 'reconnecting',
} as const;
export type ConnectionStatus =
  (typeof CONNECTION_STATUS)[keyof typeof CONNECTION_STATUS];

/**
 * Tool name of the Workflow agentic tool. Its progress is structured JSON
 * rendered by a custom WorkflowBox, so several call sites special-case it
 * (kept here so they share one literal rather than scattering 'Workflow').
 */
export const WORKFLOW_TOOL_NAME = 'Workflow';
